export default __webpack_public_path__ + "static/media/playstore2.0d339112.png";